import React from 'react';
import PropTypes from 'prop-types';

class SidebarWidget extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'SidebarWidget';
    }
    render() {
        return (
        	<div className="sidebar-widget widget-stats">
				<div className="widget-header">
					<h6>{this.props.title}</h6>
					<div onClick={this.props.onCancel} className="widget-toggle">+</div>
				</div>
				<div className="widget-content">
					{this.props.children}
				</div>
			</div>
        );
    }

}

SidebarWidget.propTypes = {
	children : PropTypes.element,
	title : PropTypes.string,
	onCancel : PropTypes.function
}

export default SidebarWidget;



// WEBPACK FOOTER //
// ./src/browser/components/ui/sidebarWidget.js